class NotaDeclaracaoComposicao{
    constructor(){
        
    }
}

export default NotaDeclaracaoComposicao
